<template>
	<nav id="navbar">
		<v-app-bar dark flat app clipped-left clipped-right color="primary">
			<v-app-bar-nav-icon @click="drawer = !drawer" class="hidden-lg-and-up" :class="$emerald.ifLang('ar', '', 'ms-1')"></v-app-bar-nav-icon>

			<v-toolbar-title>
				<router-link :to="{name: 'home'}">
					<v-img
						v-if="currentFinancialFileId && current_financial_file.company_logo_file"
						left
						contain
						:src="file_logo"
						max-width="80"
						max-height="55"
						class="shrink me-2"
						alt="N/A Logo"
						transtion="scale-transition"
					></v-img>

					<v-img
						v-else
						:src="require('../assets/EMERALD Icon.png')"
						contain
						left
						max-width="50"
						max-height="45"
						class="shrink me-2"
						transtion="scale-transition"
						alt="N/A Logo"
					></v-img>
				</router-link>
			</v-toolbar-title>
            
            <!-- menus -->
			<v-toolbar-items class="hidden-md-and-down">
				<template v-if="showMenus">
					<!-- shortcuts -->
					<v-menu v-if="useFavoritesNavigationMenu"
						offset-y
						transition="slide-y-transition"
					>
						<template v-slot:activator="{ on, attrs }">
							<v-btn
								dark
								color="transparent"
								:depressed="true"
								v-bind="attrs"
								v-on="on"
							>
								<v-icon small class="me-1">fas fa-star</v-icon>
								{{$t('favorites.name')}}
							</v-btn>
						</template>
						<v-list
							dense
							nav
						>	
							<div
								v-for="item in groups.find(v => v.name === 'favorites').items"
								class=""
								:key="item.id"
							>
								<div v-if="item.isDivider" class="pt-2 px-2 text-caption">
									<span class="greyDarken2--text">
										<v-icon small v-if="item.icon" class="mb-1" >
											{{ item.icon }}
										</v-icon>
										<span class="ms-2">{{ item.name }}</span>
									</span>
									<v-divider class="mt-1" ></v-divider>
								</div>
								<v-list-item
									v-else
									:to="item.route"
									class=""
									:class="{'grey lighten-3': $route.query.invoiceCategory == item?.route?.query?.invoiceCategory && $route.name === item.route?.name}"
									exact
									:value="false"
									link
								>
									<v-list-item-content class="text-body-1">
										<v-list-item-title>
											{{ item.text }}
										</v-list-item-title>
									</v-list-item-content>
								</v-list-item>
							</div>

						</v-list>
					</v-menu>
					<!-- accounting-->
					<v-menu
						v-if="useWarehousesPermissions ? (!isWarehouse || isAdmin) : true"
						offset-y
						transition="slide-y-transition"
					>
						<template v-slot:activator="{ on, attrs }">
							<v-btn
								dark
								color="transparent"
								:depressed="true"
								v-bind="attrs"
								v-on="on"
							>
								<v-icon small class="me-1">fa fa-briefcase</v-icon>
								{{$t('accounting.name')}}
							</v-btn>
						</template>

						<bee-list :items="groups.find(c => c.name == $t('accounting.name')).items.filter(c => c.show)"></bee-list>
					</v-menu>

					<!-- materials & warehouses-->
					<v-menu
						v-if="groups.find(c => c.name == $t('materials-warehouses.name')).show"
						v-model="materialsAndWarehousesMenu"
						offset-y
						transition="slide-y-transition"
					>
						<template v-slot:activator="{ on, attrs }">
							<v-btn
								:depressed="true"
								color="transparent"
								dark
								v-bind="attrs"
								v-on="on"
							>
								<v-icon small class="me-1">fa-warehouse</v-icon>
								{{$t('materials-warehouses.name')}}
							</v-btn>
						</template>

						<v-list dense nav>
							<div
								v-for="item in groups.find(c => c.name == $t('materials-warehouses.name')).items.filter(c => c.show)"
								:key="item.id"
							>
								<v-menu left offset-x>
									<template v-slot:activator="{ on, attrs }">
										<v-list-item
											link
											:to="item.route"
											:disabled="item.disabled"
											class="text-body-1 my-0 pe-0 d-flex align-center justify-space-between"
										>
										<v-list-item-content>
											<v-list-item-title>
												{{item.text}}
											</v-list-item-title>
										
										</v-list-item-content>
										<v-list-item-action class="ma-0" v-if="item.with_action_icon">
											<div v-on="on" v-bind="attrs"  @click.stop.prevent>
												<v-btn icon>
													<v-icon    >mdi mdi-playlist-check</v-icon>
												</v-btn>	
												<!-- <v-tooltip v-if="false" top>
													<template v-slot:activator="{on, attrs}">
														<div v-on="on" v-bind="attrs">

														</div>
													</template>
													<span>أنماط الفاتورة</span>
												</v-tooltip> -->
											</div>
										</v-list-item-action>
		
										</v-list-item>
									</template>
									<v-list
										dense
										nav
									>	
										<v-list-item
											v-for="category in 
											[{name: $t('all'), id: null}, ...invoiceCategories.filter(c => c.category_invoice_types.map(c => c.invoice_type).includes(item.type))]"
											:key="category.id"
											:to="{name: item.route.name,  ...( category.id ? {query: {invoiceCategory: category.id}} : null)}"
											link
											exact
											:disabled="category.id && !configs?.num_of_total_invoices_advance?.find(v => v.invoice_type == item.type)?.category_counts?.find(v => v.category_id === category.id)?.count"
											:class="{'grey lighten-2': $route.query.invoiceCategory == category.id && $route.name === item.route.name}"
											:value="true"
											@click="materialsAndWarehousesMenu = false"
										>
											<v-list-item-content class="text-body-1">
												<v-list-item-title>
													{{ category.name }}
												</v-list-item-title>
											</v-list-item-content>
										</v-list-item>
									</v-list>
								</v-menu>
								<v-divider class="my-1 mx-2" v-if="item.with_divider"></v-divider>
							</div>
						</v-list>
					</v-menu>
				</template>

                <!-- statistics-->
				<v-menu v-if="isAdmin && !currentFinancialFileId" offset-y transition="slide-y-transition">
					<template v-slot:activator="{ on, attrs }">
						<v-btn
							:depressed="true"
							color="transparent"
							dark
							v-bind="attrs"
							v-on="on"
							@click="
								!$route.name.includes('statistics')
								? $router.push({ name: 'statistics-final-accounts' })
								: null"
						>
							<v-icon small class="me-1">fa-chart-bar</v-icon>
							{{$t('statistics.name')}}	
						</v-btn>
					</template>
					<!-- <bee-list :items="groups.find(c => c.name == $t('statistics.name')).items"></bee-list> -->
				</v-menu>

				<!-- settings-->
				<v-menu v-if="showMenus && groups.find(c=>c.name == $t('settings.name')).show" offset-y transition="slide-y-transition">
					<template v-slot:activator="{ on, attrs }">
						<v-btn
							color="transparent"
							:depressed="true"
							dark
							v-bind="attrs"
							v-on="on"
						>
							<v-icon small class="me-1">mdi-cog-outline</v-icon>
							{{$t('settings.name')}}
						</v-btn>
					</template>
					<bee-list :items="groups.find(c=>c.name == $t('settings.name')).items.filter(c => c.show)"></bee-list>
				</v-menu>
				
				<!-- system management-->
				<v-menu v-if="groups.find(c => c.name == $t('system-management.name')).show" offset-y transition="slide-y-transition">
					<template v-slot:activator="{ on, attrs }">
						<v-btn
							v-if="isAdmin"
							color="transparent"
							:depressed="true"
							dark
							v-bind="attrs"
							v-on="on"
						>
							<v-icon small class="me-1">fa-user-shield</v-icon>
							{{$t('system-management.name')}}
						</v-btn>
					</template>
					<bee-list :items="groups.find(c => c.name == $t('system-management.name')).items.filter(c => c.show)"></bee-list>
				</v-menu>
				<!-- global Settings-->
				<v-menu v-if="isAdmin && !currentFinancialFileId" offset-y transition="slide-y-transition">
					<template v-slot:activator="{ on, attrs }">
						<v-btn
						v-bind="attrs"
						v-on="on"
							:depressed="true"
							color="transparent"
							dark
							:to="{name: 'global-settings'}"
						>
							<v-icon small class="me-1">fa fa-cog</v-icon>
							{{ $t('global-settings') }}
						</v-btn>
					</template>
					<!-- <bee-list :items="groups.find(c=>c.name == $t('settings.name')).items.filter(c => c.show)"></bee-list> -->
				</v-menu>

			</v-toolbar-items>

			<v-spacer></v-spacer>

			<v-icon type="button" size="21" class="mx-2">fa-bell</v-icon>

            <!-- users menu -->
			<v-menu bottom offset-y right transition="slide-y-transition">
				<template v-slot:activator="{ on }">
					<v-chip outlined v-on="on" class="rounded-xl">
						<v-avatar left>
							<v-icon type="button" v-on="on" class="mx-2" size="21">fa-user-circle</v-icon>
						</v-avatar>
						<span style="font-weight: 300 !important;">{{current_user_name}}</span>
					</v-chip>
				</template>
				<bee-list>
					<bee-list-item
						:context="accountSettings[1].context"
						:item="accountSettings[1]"
						@click="dialog = true"
					></bee-list-item>
					<bee-list-item
						:context="accountSettings[0].context"
						:item="accountSettings[0]"
						@click="logout()"
					></bee-list-item>
				</bee-list>
			</v-menu>

			<!-- language menu -->
			<v-menu bottom offset-y right transition="slide-y-transition">
				<template v-slot:activator="{ on }">
					<v-chip outlined v-on="on" class="rounded-xl ms-2">
						{{$i18n.locale.toLocaleUpperCase()}}
						<!-- <v-icon size="23">mdi-web</v-icon> -->
					</v-chip>
				</template>
				<bee-list>
					<bee-list-item
						v-for="(lang, index) in langs"
						:key="lang"
						:item="langListItems[index]"
						class="text-center"
						:class="{'v-list-item--active': $i18n.locale === lang}"
						dense
						@click="i18nSetLang(lang)"
						:context="langListItems[index].context"
					></bee-list-item>
				</bee-list>
			</v-menu>

			<v-divider vertical inset class="mx-2"></v-divider>

			<!-- current financial file -->
			<v-card-subtitle
				v-if="currentFinancialFileId"
				@click="dialogFileInfo = true"
				class="white--text text-center hover rounded"
				style="font-weight: 500 !important; cursor: pointer; border: 0px solid #ffffff1f; padding-block: inherit; margin-left: 9px !important;margin-right: 3px;"
			>
				{{file_name}}
				<br />
				{{file_year}}
			</v-card-subtitle>

			<v-btn
				v-else
				:to="{ name: 'quick-financial-file-selector'}"
				text
			>
				{{$t('select-financial-file')}}
			</v-btn>
		</v-app-bar>

        <!-- drawer -->
		<v-navigation-drawer  :right="$emerald.ifLang('ar', true, false)" app v-model="drawer" v-show="on_mdAndUp" temporary>
			<bee-list-item
				context="financial_file"
				@click="drawer = !drawer"
				:item="{icon: 'mdi-menu', text: showMenus ? `${file_name} - ${file_year}` : null, with_divider: false, action_name: actions.GET}"
			></bee-list-item>

			<v-divider class="mx-2"></v-divider>
			
			<bee-list-item
				v-if="!showMenus"
				context="financial_file"
				@click="
					!$route.name.includes('statistics')
						? $router.push({ name: 'statistics-final-accounts' })
						: null"
				:item="{icon: 'fa-chart-bar', text: $t('statistics.name'), with_divider: false, action_name: actions.GET}"
			></bee-list-item>
			
			<!-- <bee-list
				v-if="
					!$route.name.includes('statistics') &&
					$route.name !== 'quick-financial-file-selector'
				"
				@select="drawer = false"
				:groups="isAdmin ? groups : groups.filter(c=>c.name != this.$t('system-management.name'))"
				@click="close()"
			></bee-list> -->
			
			<!-- menus -->
			<v-list nav>
				<template
					v-if="
 						!$route.name.includes('statistics') &&
 						$route.name !== 'quick-financial-file-selector'
 					"
				>
					<v-list-group
						v-for="(group, index) in groups.filter(c => c.name !== $t('system-management.name'))"
						:key="index"
					>
						<template v-slot:activator>
							<v-list-item-icon><v-icon>{{group.icon}}</v-icon></v-list-item-icon>
							<v-list-item-title>{{group.name}}</v-list-item-title>
						</template>
						<template v-for="(item, i) in group.items">
							<v-list-item
								:key="'item-' + i"
								:to="item.route"
								@click="drawer = false"
							>
								<v-list-item-icon v-if="item.icon">
									<v-icon>{{item.icon}}</v-icon>
								</v-list-item-icon>
								<v-list-item-content>
									<v-list-item-title>{{item.text}}</v-list-item-title>
								</v-list-item-content>
							</v-list-item>
							<v-divider v-if="item.with_divider" :key="'divider-' + i"/>
						</template>
					</v-list-group>
				</template>

				<!-- system management -->
				<v-list-group v-if="isAdmin">
					<template v-slot:activator>
						<v-list-item-icon><v-icon>fa-user-shield</v-icon></v-list-item-icon>
						<v-list-item-title>{{$t('system-management.name')}}</v-list-item-title>
					</template>
					<template v-for="(item, i) in groups.find(c => c.name === $t('system-management.name')).items">
						<v-list-item
							:key="'item-' + i"
							:to="item.route"
							@click="drawer = false"
						>
							<v-list-item-icon v-if="item.icon">
								<v-icon>{{item.icon}}</v-icon>
							</v-list-item-icon>
							<v-list-item-content>
								<v-list-item-title>{{item.text}}</v-list-item-title>
							</v-list-item-content>
						</v-list-item>
						<v-divider v-if="item.with_divider" :key="'divider-' + i"/>
					</template>
				</v-list-group>
			</v-list>
		</v-navigation-drawer>

        <!-- logout dialog -->
		<bee-dialog
			:confirm-btn-content="$t('change')"
			@handler="$router.replace({ name: 'quick-financial-file-selector', query: { isChange: true } })"
			@close="dialogFileInfo = false"
			v-model="dialogFileInfo"
			:title="$t('file-name-$-fiscal-year-$', {fileName: file_name, fileYear: file_year})"
			:message="message"
		></bee-dialog>

        <!-- confirm changing password dialog -->
		<bee-confirm-dialog
			@close="logout(); reLoginDialog = false"
			v-model="reLoginDialog"
			:title="$t('change-password')"
			:message="$t('success-change-message')"
		></bee-confirm-dialog>

        <!-- change password dialog -->
		<v-form v-model="valid" ref="form">
			<v-dialog persistent v-model="dialog" max-width="400px" transition="dialog-top-transition">
				<v-card>
					<v-card-title>{{$t('change-password')}}</v-card-title>
					<v-card-text>
						<v-row class="my-0">
							<v-col cols="12" sm="12" md="12" class="pb-0">
								<bee-text-field
									context="user"
									:action-name="actions.EDIT"
									:disabled="true"
									v-model="current_user.user_name"
									:label="$t('username')"
								></bee-text-field>
							</v-col>
							<v-col cols="12" sm="12" md="12" class="pb-0">
								<bee-text-field
									context="user"
									:action-name="actions.GET"
									v-model="old_password"
									:label="$t('old-password')"
									:rules="[rules.required]"
									:append-icon="showPass ? 'mdi-eye' : 'mdi-eye-off'"
									:type="showPass ? 'text' : 'password'"
									@click-append="showPass = !showPass"
								></bee-text-field>
							</v-col>
							<v-col cols="12" sm="12" md="12" class="pb-0">
								<bee-text-field
									context="user"
									:action-name="actions.GET"
									v-model="new_password"
									:label="$t('new-password')"
									:rules="[rules.required, rules.password]"
									:append-icon="showPass ? 'mdi-eye' : 'mdi-eye-off'"
									:type="showPass ? 'text' : 'password'"
									@click-append="showPass = !showPass"
								></bee-text-field>
							</v-col>
							<v-col cols="12" sm="12" md="12" class="pb-0">
								<bee-text-field
									context="user"
									:action-name="actions.GET"
									v-model="new_password_repeated"
									:label="$t('rewrite-new-password')"
									:rules="[rules.required, rules.password]"
									:append-icon="showPass ? 'mdi-eye' : 'mdi-eye-off'"
									:type="showPass ? 'text' : 'password'"
									@click-append="showPass = !showPass"
								></bee-text-field>
							</v-col>
						</v-row>
					</v-card-text>

					<v-card-actions>
						<v-btn color="greenDarken1" text @click="changePassword()" :disabled="!valid">
							{{$t('save')}}
						</v-btn>
						<v-btn color="redDarken1" text @click="reset()">
							{{$t('cancel')}}
						</v-btn>
						<v-spacer></v-spacer>
					</v-card-actions>
				</v-card>
			</v-dialog>
		</v-form>
	</nav>
</template>

<script>
import { mapState, mapGetters } from "vuex";
// import * as settings from "../settings/index.js";
import { i18nSetLang } from '../i18n/i18n.js'
import actions from "../permissions/actions-names.js";
import ls from "../settings/localStorageExtension";
import store from "../store/index.js";
import rules from "../validation";
import { multipleWarehouses, useInvoiceCategories, useInvoicesTypes, useManufacturingBonds, useSalesStatement, useWarehousesPermissions, useTotalInvoicesStatementPage, useMaterialStatusDeliver, useOrderBuyPage, usePriceOfferPage, advanceAccountHasAccessToMaterialsTree, useFavoritesNavigationMenu} from '@/configs/global'
import { userPermission, invoiceType } from '@/helpers/enums.js';

export default {
	name: "Navigation",

	data() {
		return {
			new_password_repeated: null,
			old_password: null,
			...rules,
			reLoginDialog: false,
			dialog: false,
			showPass: false,
			valid: false,
			actions,
			dialogFileInfo: false,
			drawer: false,
			showAccounts: false,
			new_password: null,
			invoiceType,
			// languages
			langs: [],
			langListItems: [],

			currentFinancialFileId: null,
			useWarehousesPermissions,
			useTotalInvoicesStatementPage,
			useFavoritesNavigationMenu,
			materialsAndWarehousesMenu: false
		};
	},

	watch: {
		'$route.name'(val) {
			if (val === 'quick-financial-file-selector') {
				this.currentFinancialFileId = ls.getLocalFinancialFileId();
			}
		}
	},

	computed: {
		accountSettings(){
			return [
				{
					text: this.$t('logout'),
					icon: "",
					context: "user",
					action_name: actions.GET
				},
				{
					text: this.$t('change-password'),
					icon: "",
					context: "user",
					action_name: actions.GET
				}
			]
		},

		...mapState("configs", ["configs"]),
		...mapState("configs", ["system_paths"]),
		...mapState("financialFiles", ["current_financial_file"]),
		...mapState({
			userType: state => state.permissions.user_type,
			invoiceCategories: state => state.invoiceCategories.invoiceCategories,
			isAdvancedAccountant: state => state.permissions.isAdvancedAccountant
		}),
		...mapGetters({
			isAdmin: 'auth/isAdmin',
			isWarehouse: 'permissions/isWarehouse',
		}),
		...mapGetters({ current_user_name: "auth/username" }),

		current_user() {
			return ls.getLocalUser();
		},
		on_mdAndUp() {
			if (this.$vuetify.breakpoint.mdAndUp) this.close();
			return true;
		},
		file_name() {
			return this.configs?.financial_file?.company_name;
		},
		file_year() {
			return this.configs?.financial_file?.year_name;
		},
		file_logo() {
			return (
				this.current_financial_file.company_logo_file
					? (
						axios.defaults.baseURL.replace("/api/", "") +
						"/Content/FinancialFiles/Logos/" +
						this.current_financial_file.company_logo_file
					)
					: null
			);
		},

		message() {
			return this.$t('do-you-want-to-change-the-financial-file');
		},

		groups() {
			const groups = [
				{
					name: 'favorites',
					items: [
						{
							isDivider: true,
							name: 'إدارة دورة الإنتاج',
							icon: 'mdi mdi-factory'
						},
						{
							text: this.$t('favorites.items.production'),
							route: { name: 'invoices-buy', query:{ invoiceCategory: 'd3b4e73e-1d53-49e1-17a1-08de001e7f7d'}},
							with_divider: true,
							show: true
						},
						{
							text: 'إنتاج نكهات',
							route: { name:'invoices-buy', query: {invoiceCategory: '4a393cbd-633b-46ca-04ba-08de00133bb0'}}
						},
						{
							text: this.$t('favorites.items.raw-materials-consumption'),
							route: { name: 'invoices-sale', query: {invoiceCategory: 'e5c66a22-12e0-419b-99e0-08de075e543b' }},
							with_divider: true,
							show: true,
						},
						{
							name: 'إدارة المشتريات',
							icon:'fas fa-boxes',
							isDivider: true
						},
						{
							text: 'فاتورة مشتريات موردين',
							route: {name: 'invoices-buy', query: {invoiceCategory: 'f04f7728-df65-4fb5-51a4-08de0fe1d2f8'}}
						},
						{
							text: 'فاتورة مرتجع مشتريات موردين',
							route: {name: 'buy-invoice-refund', query: {invoiceCategory: '76b333ce-f43c-4e94-51a6-08de0fe1d2f8'}}
						},
						{
							name: 'إدارة المبيعات',
							icon: 'fas fa-truck-loading',
							isDivider: true
						},
						{
							text: 'فاتورة مبيعات',
							route: { name:'invoices-sale', query: {invoiceCategory: '77cb6cb5-b62d-4059-04b7-08de00133bb0'}}
						},
						// {
						// 	text: 'فاتورة مبيعات تريو',
						// 	route: {name: 'invoices-sale', query: {invoiceCategory: 'ca326c3b-4f84-485b-9722-08de1013e633'}}
						// },
						// {
						// 	text: 'فاتورة مبيعات تورتيلا',
						// 	route: {name: 'invoices-sale', query: {invoiceCategory: 'da234c5f-a3e9-4597-9723-08de1013e633'}}
						// },
						{
							text: 'فاتورة مرتجع مبيعات',
							route: { name:'sale-invoice-refund', query: {invoiceCategory: '1312e021-14ab-4e9a-4b36-08de107a8332'}}
						},
						// {
						// 	text: 'فاتورة مرتجع مبيعات تريو',
						// 	route: {name: 'sale-invoice-refund', query: {invoiceCategory: '137cc252-aa41-46b7-51a5-08de0fe1d2f8'}}
						// },
						// {
						// 	text: 'فاتورة مرتجع مبيعات تورتيلا',
						// 	route: { name: 'sale-invoice-refund', query: {invoiceCategory: 'c85fda4e-2756-4f12-4b37-08de107a8332'}}
						// },
						{
							isDivider: true,
							icon: 'fas fa-warehouse',
							name: 'إدارة حركة المخزون'
						},
						{
							text: this.$t('favorites.items.transfer'),
							route: { name: 'transfer-document'},
							with_divider: false,
							show: true
						},
						{
							isDivider: true,
							icon: 'mdi mdi-wrench',
							name: 'إدارة نظام الصيانة'
						},
						{
							text: this.$t('favorites.items.maintenance-purchases'),
							route: { name: 'invoices-buy', query: {invoiceCategory: '1ae37032-6a4b-4bfa-04b8-08de00133bb0' }},
							with_divider: false,
							show: true
						},
						{
							text: this.$t('favorites.items.maintenance-consumption'),
							route: { name: 'invoices-sale', query: {invoiceCategory: '9ce81c60-0848-4e69-04b9-08de00133bb0'}},
							with_divider: false,
							show: true
						},
						{
							text: this.$t('favorites.items.disposal'),
							route: { name: 'invoices-sale', query: {invoiceCategory: '2eaed9a7-fabb-4b8e-a27e-08de000cf5a2'}},
							with_divider: false,
							show: true
						}
					]
				},
				{
					name: this.$t('accounting.name'),
					icon: "fa fa-briefcase",
					items: [
						{
							text: this.$t('accounting.items.accounts-tree'),
							icon: "",
							route: { name: "accounts-tree" },
							with_divider: true,
							context: "account",
							action_name: actions.GET,
							show: useWarehousesPermissions ? (!this.isWarehouse && this.userType !== userPermission.treasurer) : true
						},
						{
							text: this.$t('accounting.items.accounting-journal'),
							icon: "",
							route: { name: "accounting-journal" },
							with_divider: false,
							context: "bond",
							action_name: actions.GET,
							show: useWarehousesPermissions ? (!this.isWarehouse ) : true
						},
						{
							text: this.$t('accounting.items.cash-journal'),
							icon: "",
							route: { name: "cash-journal" },
							with_divider: false,
							context: "bond",
							action_name: actions.GET,
							show: useWarehousesPermissions ? (!this.isWarehouse ) : true
						},
						{
							text: this.$t('accounting.items.journal-table'),
							icon: "",
							route: { name: "journal-table" },
							with_divider: true,
							context: "daily_table",
							action_name: actions.GET,
							show: useWarehousesPermissions ? (!this.isWarehouse && this.userType !== userPermission.treasurer) : true
						},
						{
							text: this.$t('accounting.items.account-statement'),
							icon: "",
							route: { name: "account-statement" },
							with_divider: false,
							context: "statement",
							action_name: actions.GET,
							show: useWarehousesPermissions ? (!this.isWarehouse && this.userType !== userPermission.treasurer) : true
						},
						{
							text: this.$t('accounting.items.advance-statement'),
							icon: "",
							route: { name: "advance-statement" },
							with_divider: false,
							context: "statement",
							action_name: actions.GET,
							show: this.userType !== userPermission.treasurer
						},
						{
							text: this.$t('accounting.items.account-custom-statement'),
							icon: "",
							route: { name: "account-custom-statement" },
							with_divider: true,
							context: "custom_statement",
							action_name: actions.GET,
							show: useWarehousesPermissions ? (!this.isWarehouse && this.userType !== userPermission.treasurer) : true
						},
						{
							text: this.$t('accounting.items.trial-balance'),
							icon: "",
							route: { name: "trail-balance" },
							with_divider: false,
							context: "trial_balance",
							action_name: actions.GET,
							show: useWarehousesPermissions ? (!this.isWarehouse && this.userType !== userPermission.treasurer) : true
						},
						{
							text: this.$t('accounting.items.final-accounts'),
							icon: "",
							route: { name: "final-accounts" },
							with_divider: false,
							context: "final_account",
							action_name: actions.GET,
							show: useWarehousesPermissions ? (!this.isWarehouse && this.userType !== userPermission.treasurer) : true
						}
					]
				},
				{
					name: this.$t('materials-warehouses.name'),
					icon: "fa-warehouse",
					show: this.userType !== userPermission.treasurer,
					items: [
						{
							text: this.$t('materials-warehouses.items.invoices-sale'),
							icon: "",
							route: { name: "invoices-sale" },
							with_divider: false,
							with_action_icon: useInvoiceCategories,
							type: invoiceType.sale,
							context: "invoice",
							action_name: actions.GET,
							show: true
						},
						{
							text: this.$t('materials-warehouses.items.invoices-buy'),
							icon: "",
							route: { name: "invoices-buy" },
							with_divider: false,
							with_action_icon: useInvoiceCategories,
							type: invoiceType.buy,
							context: "invoice",
							action_name: actions.GET,
							show: true
						},
						{
							text: this.$t('materials-warehouses.items.sale-invoice-refund'),
							icon: "",
							route: { name: "sale-invoice-refund" },
							with_divider: false,
							with_action_icon: useInvoiceCategories,
							type: invoiceType.saleRefund,
							context: "invoice",
							action_name: actions.GET,
							show:  true
						},
						{
							text: this.$t('materials-warehouses.items.buy-invoice-refund'),
							icon: "",
							route: { name: "buy-invoice-refund" },
							with_divider: false,
							with_action_icon: useInvoiceCategories,
							type: invoiceType.buyRefund,
							context: "invoice",
							action_name: actions.GET,
							show: this.userType !== userPermission.treasurer
						},
						{
							text: this.$t('materials-warehouses.items.invoices'),
							icon: '',
							route: {name: 'invoices'},
							with_divider: true,
							action_name: actions.GET,
							context: 'invoice',
							show: true
						},
						{
							text: this.$t('materials-warehouses.items.buy-order'),
							icon: '',
							route: {name: 'buy-order'},
							with_divider: true,
							action_name : actions.GET,
							context: 'invoice',
							show: useOrderBuyPage
						},
						{
							text: this.$t('materials-warehouses.items.price-offer'),
							icon: '',
							route: {name: 'price-offer'},
							with_divider: false,
							action_name: actions.GET,
							context: 'invoice',
							show: usePriceOfferPage && !this.isWarehouse
						},
						{
							text: this.$t('materials-warehouses.items.offers'),
							icon: '',
							route: {name: 'offers'},
							with_divider: true,
							actions_name: actions.GET,
							context: 'invoice',
							show: usePriceOfferPage && !this.isWarehouse
						},
						{
							text: this.$t('materials-warehouses.items.total-invoices-statement'),
							icon: "",
							route: { name: "total-invoices-statement" },
							context: "invoice",
							show: useTotalInvoicesStatementPage,
							action_name: actions.GET
						},
						{
							text: this.$t('materials-warehouses.items.sales-statement'),
							icon: "",
							route: { name: "sales-statement" },
							with_divider: true,
							context: "invoice",
							show: useSalesStatement,
							action_name: actions.GET
						},
						{
							text: this.$t('materials-warehouses.items.materials-tree'),
							icon: "",
							route: {
								name: "materials-tree",
								params: { warehouseId: Number(this.configs?.warehouse?.id) }
							},
							with_divider: false,
							context: "warehouse",
							action_name: actions.GET,
							show: useWarehousesPermissions ? (this.isWarehouse || this.isAdmin || (this.isAdvancedAccountant && advanceAccountHasAccessToMaterialsTree)) : true
						},
						{
							text: this.$t('materials-warehouses.items.materials-journal'),
							icon: "",
							route: { name: "materials-journals" },
							with_divider: true,
							context: "bond",
							action_name: actions.GET,
							show: useWarehousesPermissions ? (this.isWarehouse || this.isAdmin) : true
						},
						{
							text: this.$t('materials-warehouses.items.transfer-document'),
							icon: "",
							route: { name: "transfer-document" },
							with_divider: false,
							context: "bond",
							action_name: actions.GET,
							show: multipleWarehouses && (
								(this.isWarehouse && this.userType === userPermission.warehouseManger) || this.isAdmin
							)
						},
						{
							text: this.$t('materials-warehouses.items.manufacturing-bond'),
							icon: "",
							route: { name: "manufacturing-bond" },
							with_divider: useWarehousesPermissions ? (this.isWarehouse || this.isAdmin) : true,
							context: "bond",
							action_name: actions.GET,
							show: useManufacturingBonds
						},
						{
							text: this.$t('materials-warehouses.items.material-statement'),
							icon: "",
							route: { name: "material-statment" },
							with_divider: false,
							context: "statement",
							action_name: actions.GET,
							show: useWarehousesPermissions ? (this.isWarehouse || this.isAdmin) : true,
						},
						{
							text: this.$t('materials-warehouses.items.warehouse-inventory'),
							icon: "",
							route: { name: "warehouses-inventory" },
							with_divider: false,
							context: "statement",
							action_name: actions.GET,
							show: useWarehousesPermissions ? (this.isWarehouse || this.isAdmin) : true,
						}
					]
				},
				// {
				// 	name: this.$t('statistics.name'),
				// 	icon: "fa-chart-bar",
				// 	items: []
				// },
				{
					name: this.$t('settings.name'),
					icon: "mdi-cog-outline",
					show: useWarehousesPermissions ? ((!this.isWarehouse || this.userType !== userPermission.warehouseKeeper) && this.userType !== userPermission.treasurer) : true,
					items: [
						{
							text: this.$t('settings.items.general-settings'),
							icon: "",
							route: { name: "settings" },
							with_divider: !this.isAdmin,
							context: "user_preferences",
							action_name: actions.GET,
							show: useWarehousesPermissions ? (!this.isWarehouse || this.isAdmin) : true
						},
						{
							text:this.$t('settings.items.financial-file-settings'),
							icon: "",
							route: { name: "financial-file-settings" },
							with_divider: true,
							context: "user_preferences",
							action_name: actions.GET,
							show: this.isAdmin
						},
						{
							text: this.$t('settings.items.financial-file-accounts'),
							icon: "",
							route: { name: "default-accounts" },
							with_divider: false,
							context: "account",
							action_name: actions.GET,
							show: useWarehousesPermissions ? (!this.isWarehouse || this.isAdmin) : true
						},
						{
							text: this.$t('settings.items.custom-statements'),
							icon: "",
							route: { name: "custom-statements" },
							with_divider: !useInvoiceCategories,
							context: "custom_statement",
							action_name: actions.GET,
							show: useWarehousesPermissions ? (!this.isWarehouse || this.isAdmin) : true
						},
						{
							text: this.$t('system-management.items.invoice-categories'),
							icon: "",
							route: { name: "invoice-categories" },
							context: "financial_file",
							action_name: actions.GET,
							with_divider: !useMaterialStatusDeliver ? true : false,
							show:
								useInvoiceCategories
									? this.currentFinancialFileId && useWarehousesPermissions
										? (!this.isWarehouse || this.isAdmin)
										: true
									: false
						},
						{
							text: this.$t('system-management.items.material-statuses'),
							icon: "",
							route: { name: "material-statuses" },
							context: "financial_file",
							action_name: actions.GET,
							with_divider: false,
							show: Boolean(useMaterialStatusDeliver && this.currentFinancialFileId)
						},
						// {
						// 	text: this.$t('settings.items.color-management'),
						// 	icon: "",
						// 	route: { name: "colors" },
						// 	with_divider: true,
						// 	context: "user_preferences",
						// 	action_name: actions.GET,
						// 	show: this.isAdmin
						// },
						{
							text: this.$t('settings.items.invoices-types'),
							route: { name: "invoices-types" },
							with_divider: false,
							context: "user_preferences",
							show: useInvoicesTypes,
							action_name: actions.GET
						},
						{
							text: this.$t('system-management.items.currencies'),
							icon: "",
							route: { name: "currencies" },
							context: "currency",
							action_name: actions.GET,
							show: this.currentFinancialFileId
						},
						{
							text: this.$t('settings.items.warehouses'),
							icon: "",
							route: { name: "warehouses" },
							with_divider: false,
							context: "warehouse",
							action_name: actions.GET,
							show: useWarehousesPermissions ? (this.isWarehouse || this.isAdmin) : true
						},
						{
							text: this.$t('settings.items.measuring-units'),
							icon: "",
							route: { name: "unit-sizes" },
							with_divider: true,
							context: "unit_size",
							action_name: actions.GET,
							show: useWarehousesPermissions ? (!this.isWarehouse || this.isAdmin) : true
						},
						{
							text: this.$t('system-management.items.audit-log'),
							icon: "",
							route: { name: "audit-log" },
							context: "financial_file",
							action_name: actions.GET,
							show: this.currentFinancialFileId && (useWarehousesPermissions ? !this.isWarehouse : true)
						},
						// {
						// 	text: "UI " + settings.UI_VERSION,
						// 	icon: "",
						// 	with_divider: false,
						// 	show: true,
						// 	context: "daily_table", /////////// WILL REMOVE /////
						// 	action_name: actions.GET
						// }
					]
				},
				{
					name: this.$t('system-management.name'),
					icon: "fa-user-shield",
					show: this.userType !== userPermission.treasurer,
					items: [
						{
							text: this.$t('system-management.items.users'),
							icon: "",
							route: { name: "users" },
							context: "user",
							action_name: actions.EDIT,
							show: true
						},
						{
							text: this.$t('system-management.items.financial-files'),
							icon: "",
							route: { name: "financial-files" },
							context: "financial_file",
							action_name: actions.EDIT,
							show: true
						},
						{
							text: this.$t('system-management.items.currencies'),
							icon: "",
							route: { name: "currencies" },
							context: "currency",
							action_name: actions.GET,
							show: !this.currentFinancialFileId
						}
					]
				}
			];

			return groups;
		},

		showMenus() {
			return (
				ls.getLocalFinancialFileId() &&
				!['login','quick-financial-file-selector'].includes(this.$route.name) &&
				!this.$route.name.includes('statistics')
			)
		},
		// noSelectedFinancialFile() {
		// 	return !Object.keys(this.configs).length
		// }
	},

	methods: {
		close() {
			this.drawer = false;
        },
        
        // TODO remove forwardToHome, it's not used
		forwardToHome() {
			this.drawer = false;
			this.$router.push({
				name: "home"
			});
			close();
        },
        
		logout() {
			store.dispatch("auth/logout").then(() => {
				this.$router.replace({ name: "login" }).then(() => {
					this.$router.go(0); // Force refresh to empty the store
				});
			});
		},
		changePassword() {
			store.dispatch("users/changePassword", {
                old_password: this.old_password,
                new_password: this.new_password,
                new_password_repeated: this.new_password_repeated
            })
            .then(() => {
                this.reset();
                this.reLoginDialog = true;
            });
		},
		reset() {
			this.dialog = false;
			this.new_password = null;
			this.old_password = null;
			this.new_password_repeated = null;
			this.showPass = false;
			setTimeout(() => {
				this.$nextTick(() => {
					this.$refs.form.resetValidation();
				});
			}, 501);
		},

		// languages
		initLanguages(){
			this.langs = this.$i18n.availableLocales;
			this.langs.forEach(lang => {
				this.langListItems.push({
					text: lang.toLocaleUpperCase(),
					icon: "",
					disabled: false,
					context: "user",
					action_name: actions.GET
				})
			});
		},
		
		i18nSetLang,
	},

	mounted(){
		this.initLanguages();
		// add the setTimeout to make sure that the value has been updated successfully (to get the updated value)
		setTimeout(() => {
			this.currentFinancialFileId = ls.getLocalFinancialFileId();
		})
	},

	i18n: {
		messages: {
			ar: {
				favorites: {
					name: 'العمليات',
					items: {
						'production': 'إنتاج طبليات',
						'raw-materials-consumption': 'استهلاك إنتاج',
						'disposal': 'إتلاف',
						'maintenance-consumption': 'استهلاك صيانة',
						'maintenance-purchases': 'مشتريات صيانة',
						'transfer': 'سند مناقلة'
					}
				},
				accounting: {
					name: 'المحاسبة',
					items: {
						'accounts-tree': 'شجرة الحسابات',
						'accounting-journal': 'اليومية المحاسبية',
						'cash-journal': 'اليومية النقدية',
						'journal-table': 'جدول اليومية',
						'account-statement': 'كشف حساب',
						'account-custom-statement': 'كشف حساب مخصص',
						'trial-balance': 'ميزان المراجعة',
						'final-accounts': 'الحسابات الختامية',
						'advance-statement': 'كشف أستاذ'
					}
				},

				'materials-warehouses': {
					name: 'المواد والمستودعات',
					items: {
						'invoices-sale': 'فاتورة بيع',
						'invoices-buy': 'فاتورة شراء',
						'sale-invoice-refund': 'فاتورة مرتجع بيع',
						'buy-invoice-refund': 'فاتورة مرتجع شراء',
						'invoices': 'الفواتير',
						"buy-order": "طلبية شراء",
						"price-offer": "عرض سعر",
						"offers": "عروض السعر",
						'sales-statement': 'كشف مبيعات',
						'materials-tree': 'شجرة المواد',
						'materials-journal': 'يومية المواد',
						'manufacturing-bond': 'سند التصنيع',
						'material-statement': 'كشف مادة',
						'warehouse-inventory': 'جرد المواد',
						'transfer-document': 'سند مناقلة',
						'total-invoices-statement': 'كشف الفواتير',
					}
				},

				statistics: {
					name: 'الإحصائيات'
				},

				settings: {
					name: 'الإعدادات',
					items: {
						'general-settings': 'الإعدادات العامة',
						'financial-file-settings': "إعدادات الملف المالي",
						'financial-file-accounts': 'الحسابات الافتراضية',
						'custom-statements': 'الكشوف المخصصة',
						'warehouses': 'المستودعات',
						'measuring-units': 'واحدات القياس',
						'invoices-types': 'أنواع الفواتير',
						'color-management': 'إدارة الألوان'
					}
				},

				'system-management':{
					name: 'إدارة النظام',

					items: {
						users: 'المستخدمين',
						'financial-files': 'الملفات المالية',
						'currencies': 'العملات',
						'audit-log': 'سجلات المراقبة',
						'invoice-categories': 'أنماط الفواتير',
						'material-statuses': 'حالات المادة'
					}
				},

				change: 'تغيير',
				'change-password': 'تغيير كلمة المرور',
				'success-change-message': 'تم تحديث كلمة السر، يتوجب عليك إعادة تسجيل الدخول.',
				"all": 'الكل',
				username: 'اسم المستخدم',
				'old-password': 'كلمة المرور القديمة',
				'new-password': 'كلمة المرور الجديدة',
				'rewrite-new-password': 'أعد كلمة المرور الجديدة',

				'file-name-$-fiscal-year-$': 'اسم الملف: {fileName} - السنة المالية: {fileYear}',
				'do-you-want-to-change-the-financial-file':'هل تريد تغيير الملف المالي؟',

				'save': 'حفظ',
				'cancel': 'إلغاء',
				logout: 'تسجيل الخروج',
				'select-financial-file': 'اختر ملف'
			},
			
			en: {
				accounting: {
					name: 'Accounting',
					items: {
						'accounts-tree': 'Accounts Tree',
						'accounting-journal': 'Accounting Journal',
						'cash-journal': 'Cash Journal',
						'journal-table': 'Journal',
						'account-statement': 'Account Statement',
						'account-custom-statement': 'Customised Account Statement',
						'trial-balance': 'Trial Balance',
						'final-accounts': 'Final Accounts',
						'advance-statement': 'Ledger Statement'
					}
				},

				'materials-warehouses': {
					name: 'Items & warehouses',
					
					items: {
						'invoices-sale': 'Sale Invoices',
						'invoices-buy': 'Purchase Invoices',
						'sale-invoice-refund': 'Sale invoice refund',
						'buy-invoice-refund': 'Purchase invoice refund',
						'invoices': 'Invoices',
						"buy-order": "buy order",
						"price-offer": "Price offer",
						"offers": "Price offers",
						'sales-statement': 'Sales statement',
						'materials-tree': 'Items Tree',
						'materials-journal': 'Items Journal',
						'manufacturing-bond': 'Manufacturing Bond',
						'material-statement': 'Item Statement',
						'warehouse-inventory': 'Warehouse inventory',
						'transfer-document': 'Transfer document',
						'total-invoices-statement': 'Invoices Statment'
					}
				},

				statistics: {
					name: 'Statistics'
				},

				settings: {
					name: 'Settings',
					items: {
						'general-settings': 'General Settings',
						'financial-file-settings': "Financial file settings",
						'financial-file-accounts': 'Default accounts',
						'custom-statements': 'Customised Statements',
						'warehouses': 'Warehouses',
						'measuring-units': 'Units',
						'invoices-types': 'Invoices types',
						'color-management': 'Color Management'
					}

				},

				'system-management':{
					name: 'System management',

					items: {
						users: 'Users',
						'financial-files': 'Financial Files',
						'currencies': 'Currencies',
						'audit-log': 'Audit Log',
						'invoice-categories': 'Invoice Categories',
						'material-statuses': 'Material Statuses'
					}
				},
				en: 'All',
				change: 'Change',
				'change-password': 'Change Password',
				'success-change-message': 'Your password has been updated, please sign in again.',

				username: 'Username',
				'old-password': 'Old password',
				'new-password': 'New password',
				'rewrite-new-password': 're-enter new password',

				'file-name-$-fiscal-year-$': 'File name: {fileName} - Fiscal year: {fileYear}',
				'do-you-want-to-change-the-financial-file': 'Do you want to change the financial file?',

				'save': 'Save',
				'cancel': 'Cancel',
				logout: 'Sign out',
				'select-financial-file': 'Select financial file'
			},
			
			es: {
				accounting: {
					name: 'Contabilidad',
					items: {
						'accounts-tree': 'Árbol de cuentas',
						'accounting-journal': 'Diario contable',
						'cash-journal': 'Diario de caja',
						'journal-table': 'Horario diario',
						'account-statement': 'Estado de cuenta',
						'account-custom-statement': 'Estado de cuenta personalizado',
						'trial-balance': 'Balance de prueba',
						'final-accounts': 'Cuentas finales',
						'advance-statement': 'Estado de cuenta'
					}
				},

				'materials-warehouses': {
					name: 'Artículos y almacenes',

				 	items: {
						'invoices-sale': 'Factura de venta',
						'invoices-buy': 'Factura de compra',
						'sale-invoice-refund': 'Factura de venta devuelta',
						'buy-invoice-refund': 'Factura de compra devuelta',
						'buy-order': 'orden de compra',
						"price-offer": "Oferta de precio",
						"offers": "Ofertas de precio",
						'invoices': 'Facturas',
						'sales-statement': 'Declaración de venta',
						'materials-tree': 'Árbol de artículos',
						'materials-journal': 'Diario de artículos',
						'manufacturing-bond': 'Bono de fabricación',
						'material-statement': 'Estado de artículo',
						'warehouse-inventory': 'Inventario de Almacén',
						'transfer-document': 'Documento de transferencia',
						'total-invoices-statement': 'Estado de facturas'
					}			
				},

				statistics: {
					name: 'Estadísticas'
				},

				settings: {
					name: 'Ajustes',
					items: {
						'general-settings': 'Ajustes generales',
						'financial-file-settings': "Ajustes del archivo financiero",
						'financial-file-accounts': 'Cuentas predeterminadas',
						'custom-statements': 'Estados personalizados',
						'warehouses': 'Almacenes',
						'measuring-units': 'Unidades',
						'invoices-types': 'Tipos de facturas',
					}
				},

				'system-management':{
					name: 'Gestión de sistema',

					items: {
						users: 'Usuarios',
						'financial-files': 'Archivos financieros',
						'currencies': 'monedas',
						'audit-log' : 'registro de auditoría',
						'invoice-categories': 'categorías de factura',
						'material-statuses': 'estados de la materia'
					}
				},
				
				change: 'Cambiar',
				'change-password': 'Cambiar contraseña',
				'success-change-message': 'Su contraseña ha sido actualizada, debe volver a iniciar sesión.',
				en: 'Todos',
				username: 'Usuario',
				'old-password': 'Contraseña antigua',
				'new-password': 'Contraseña nueva',
				'rewrite-new-password': 'Repetir la nueva contraseña',
				'file-name-$-fiscal-year-$': 'Nombre de archivo: {fileName} - Año fisical: {fileYear}',
				'do-you-want-to-change-the-financial-file':'¿Quieres cambiar el archivo financiero?',
				
				'save': 'Guardar',
				'cancel': 'Cancelar',
				logout: 'Cerrar sessión',
				'select-financial-file': 'Seleccionar archivo financiero'
			}
		}
	}
};
</script>
<style scoped>
.hover:hover {
	background-color: rgba(255, 255, 255, 0.2) !important;
}

</style>

